/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as ActionTypes from './ActionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

// dispatch function for tab data for request Invoices qtr not paid screen
export const mcoClaimsSearchObj = (data) => ({
  type: ActionTypes.GET_MCO_CLAIMS_SEARCH_OBJ,
  screenData: data,
});
export const dispatchAllMfgChecked = (data) => ({
  type: ActionTypes.DISPATCH_ALL_MFG_CHECKED,
  payload: data,
});
// loading tHE api data
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

// To get plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};

// rebate programe dispatch function
export const setRebatePrograme = (data) => ({
  type: ActionTypes.SET_REBATE_PROGRAM,
  payload: data,
});

//  get rebate programe funnction
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};

//  error msg dispatch function
export const dispatchErrorMsgMCOClaims = (data) => ({
  type: ActionTypes.GET_ERROR_MSG_MCO_CLAIMS,
  payload: data,
});
// dispatch display screen feild
// select option dispatch
export const getSelectedOption = (data) => ({
  type: ActionTypes.SELECT_OPTION,
  payload: data,
});
export const dispatchURAtype = (data) => ({
  type: ActionTypes.DISPLAY_URA_TYPE,
  payload: data,
});

// Display Data clear issue.
export const dispatchDisplayObjMcoClaims = (data) => ({
  type: ActionTypes.SET_DISPLAY_OBJ_MCO_CLAIMS,
  payload: data,
});

export const dispatchQtrValue = (data) => ({
  type: ActionTypes.DISPATCH_QTR_VALUE,
  payload: data,
});
// Manufactuerer Name Display
export const getManufactureName = (value) => ({
  type: ActionTypes.GET_MANUFACTURER_NAME_ACT,
  allManufacturer: value,
});
// Manufacturer ID display
export const getManufactureID = (value) => ({
  type: ActionTypes.GET_MANUFACTURER_ID_ACT,
  manufactureWithIds: value,
});

// Refresh Functinality
export const refreshMcoClaims = () => ({
  type: ActionTypes.REFRESH_MCO_CLAIMS,
  payload: {},
});
export const refreshMcoClaimsDisplay = () => ({
  type: ActionTypes.REFRESH_MCO_CLAIMS_DISPLAY,
  payload: {},
});
// dispatch Maanufacturer list
const setManufactureList = (data) => ({
  type: ActionTypes.SET_MANUFACTURERS_LIST,
  payload: data,
});

// get manufacturer list
export const getManufacturerList = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_MANUFACTURERS_DATA_LIST, values)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(
        setManufactureList(response?.data?.rebatePercentOfSpendMfgGridVO)
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setManufactureList([]));
    });
};

// This action show error message for 5 sec for no contract exists
const showNoDataMessage = () => async (dispatch) => {
  // setTimeout(() => {
    // dispatch(dispatchErrorMsgMCOClaims([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgMCOClaims([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
  // Promise.resolve().then(() => {
  //   dispatch(dispatchErrorMsgMCOClaims([]));
  // });
};

// dispatch MCO Claims API
const dispatchMCOClaimsData = (data) => ({
  type: ActionTypes.SET_MCO_CLAIMS_DATA,
  payload: data,
});

// get manufacturer list
export const getMCOClaimsData = (values, isSearchClicked = false) => (dispatch) => {
  dispatch(setLoading(true));
  dispatch(dispatchMCOClaimsData([]));
  return axios
    .post(serviceEndPoint.GET_MCO_CLAIMS_DATA, values)
    .then((response) => {
      dispatch(setLoading(false));
      const data = response?.data?.mcoClaimsGridVO || [];
      if (data.length === 0) {
        if (isSearchClicked) {
          dispatch(showNoDataMessage());
        }
      } else {
        dispatch(dispatchMCOClaimsData(data));
      }
    })
    .catch(() => {
      dispatch(setLoading(false));
      dispatch(dispatchMCOClaimsData([]));
    });
};